import {
    HttpClient,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IMLSkill,
    ODataResponse,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';

@Injectable()
export class MLSkillsService extends ODataService<IMLSkill, string> {
    protected _endpoint = '/odata/MLSkills';

    constructor(http: HttpClient) {
        super(http, MapperService.mlSkillMap);
    }

    public createMLSkill(data: IMLSkill, mlpackageVersionId: string) {
        const MLSkillCreationRequest = {
            Description: data.description,
            MlPackageId: data.modelId,
            MlPackageVersionId: mlpackageVersionId,
            Name: data.name,
            Processor: data.processor,
        };

        const payload = { MLSkillCreationRequest: MLSkillCreationRequest };

        const req = new HttpRequest('POST', `${this._endpoint}/UiPath.Server.Configuration.OData.CreateMLSkill`, JSON.stringify(payload));
        return this._http.request(req);
    }

    public rollbackMLSkillToPreviousVersion(mlskillId: string): Observable<ODataResponse<any>> {
        return this._http.post<any>(`${this._endpoint}('${mlskillId}')/UiPath.Server.Configuration.OData.RollbackToPreviousVersion`, null);
    }
}
